import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import dateFormat from "dateformat";

import { cs2Actions } from '../_actions';

function FileUpload() {
	
    const user = useSelector(state => state.authentication.user);
    const efpPartner = useSelector(state => state.authentication.user.efpPartners)
    const uploading = useSelector(state => state.cs2FileUpload.uploading);
    const alert = useSelector(state => state.alert);
    const dispatch = useDispatch();
    const [uploadFile, setUploadFile] = useState();
    const [submitted, setSubmitted ] = useState();
    

    
    const [inputs, setInputs] = useState({
        contactName: user.shortName,
        contactPhone: user.officePhone,
        tradeDate: dateFormat(new Date(), "mm/dd/yyyy"),
        firmGroup: efpPartner.bpCompanyName,
        fileName: ''
        	
    });
    
    const { contactName, contactPhone, tradeDate, firmGroup, fileName } = inputs;

    useEffect(() => {
        //dispatch(userActions.getAll());
        {alert.message &&
            setSubmitted(false);
            setInputs(inputs => ({ ...inputs, "fileName": "" }));

        }
        
    }, [alert]);

    function handleChange(e) {

        //dispatch(alertActions.clear());

        const { name, value } = e.target;
        setInputs(inputs => ({ ...inputs, [name]: value }));
        
        if (e.target.name == 'fileName') {
        	setUploadFile(e.target.files[0]);
        }
    	  
    }

    function handleSubmit(e) {


        e.preventDefault();

        setSubmitted(true);
        if (fileName) {
        	var fileReader = new FileReader();
        	
        	fileReader.addEventListener("loadend", function() {
        		
        		// get return url from location state or default to home page
            	console.log("--------------------- location.state: " + JSON.stringify(location.state));
                const { from } = location.state || { from: { pathname: "/applications" } };
                console.log("--------------------- from: " + JSON.stringify(from));
                dispatch(cs2Actions.cs2FileSubmission(fileReader.result));
        	});
        
        	fileReader.readAsText(uploadFile);
        	  
        }
    }
    
    function fileSelectedHandler(event) {
    	console.log(event.target.files[0]);
    	//setUploadFile(event.target.files[0]);
        //dispatch(userActions.delete(id));
    }

    function fileUploadHandler() {
    	var fileReader = new FileReader();
    	fileReader.readAsText(this.files[0]);
    	setUploadFile(fileReader.result);
    	
    }
    
    return (
   		<div>
	  		<div className="row">
	    		<div className="col-md-8" >
	    			<h3>CS2 File Upload</h3>
	    		</div>
    		</div>
    		<div className="border border-secondary" >
    		<form name="form" onSubmit={handleSubmit} className="col-md-5" >
            <div className="form-group">
                <label>Contact Name</label>
                <input type="text" name="contactName" value={contactName} onChange={handleChange} className={'form-control' + (submitted && !contactName ? ' is-invalid' : '')} disabled />
                {submitted && !contactName &&
                    <div className="invalid-feedback">Contact name is required</div>
                }
            </div>
            <div className="form-group">
                <label>Contact Phone</label>
                <input type="text" name="contactPhone" value={contactPhone} onChange={handleChange} className={'form-control' + (submitted && !contactPhone ? ' is-invalid' : '')} disabled />
                {submitted && !contactPhone &&
                    <div className="invalid-feedback">Contact phone is required</div>
                }
            </div>
            <div className="form-group">
	            <label>Trade Date</label>
	            <input type="text" name="tradeDate" value={tradeDate} onChange={handleChange} className={'form-control' + (submitted && !tradeDate ? ' is-invalid' : '')} disabled />
	            {submitted && !tradeDate &&
	                <div className="invalid-feedback">Trade date is required</div>
	            }
            </div>
            <div className="form-group">
		        <label>Firm Group</label>
		        <input type="text" name="firmGroup" value={firmGroup} onChange={handleChange} className="form-control form-control-lg" disabled />
		        {submitted && !firmGroup &&
		            <div className="invalid-feedback">Firm group is required</div>
		        }
	        </div>
	        <div className="form-group">
		        <label>File Name</label>
		        <input type="file" name="fileName" value={fileName} onChange={handleChange} className={'form-control' + (submitted && !fileName ? ' is-invalid' : '')}  />
		        {submitted && !fileName &&
		            <div className="invalid-feedback">File is required</div>
		        }
			</div>
            <div className="form-group">
                <button className="btn btn-primary">
                    {uploading && <span className="spinner-border spinner-border-sm mr-1"></span>}
                    Upload File
                </button>
                {uploading && <em>  Loading file... Please, wait</em>}
            </div>
            <div className="form-group">
            {!uploading && alert.message &&
                <div className={`alert ${alert.type}`}><strong>Code : </strong> {alert.message.code}<br/><strong>Type : </strong>{alert.message.type}<br/><strong>Description : </strong> {alert.message.description}</div>
            }
            {/* users.error && <span className="text-danger">ERROR: {users.error}</span> */}
            </div>
        </form>
    		
     		</div>
		</div>
    );
}

export { FileUpload };